import addHours from 'date-fns/addHours';
import type { IAiToolsState } from 'reactApp/modules/aiTools/aiTools.types';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getAiToolsState = (state: RootState): IAiToolsState => state.aiTools;

export const isAiImageImproveAvailable = createSelector(getAiToolsState, (state) => state.attemptsAvailable > 0);
export const getAiImageImproveAvailableAttempts = createSelector(getAiToolsState, (state) => state.attemptsAvailable);
export const getAiRmvBgrndAvailableAttempts = createSelector(getAiToolsState, (state) => state.attemptsRmvBgrndAvailable);

export const getImageImprovingState = createSelector(
    getAiToolsState,
    (_, id: string) => id,
    (state, id: string) => state.processors[id]?.state
);

export const getAiImageImproveNewImage = createSelector(
    getAiToolsState,
    (_, id: string) => id,
    (state, id: string) => state.processors[id]?.imageResult
);

export const getAiProcessType = createSelector(
    getAiToolsState,
    (_, id: string) => id,
    (state, id: string) => state.processors[id]?.type
);

export const getIsNewbackground = createSelector(
    getAiToolsState,
    (_, id: string) => id,
    (state, id: string) => state.processors[id]?.isNewbackground
);

export const getAiToolsStartTime = createSelector(getAiToolsState, (state) => state.startTime);
export const getAiToolsRmvBgrndStartTime = createSelector(getAiToolsState, (state) => state.startTimeRmvBgrnd);
export const getAiToolsEndTime = createSelector(getAiToolsStartTime, (startTime) => startTime && addHours(startTime, 24).valueOf());
export const getAiToolsRmvBgrndEndTime = createSelector(
    getAiToolsRmvBgrndStartTime,
    (startTime) => startTime && addHours(startTime, 24).valueOf()
);
